(function(algolia) {
// 001
  'use strict';
  const insightsClient = algolia.externals.insightsClient;
  const createAlgoliaInsightsPlugin = algolia.externals.createAlgoliaInsightsPlugin;
  const createInsightsMiddleware = algolia.externals.createInsightsMiddleware;
  algolia.userTokenCheck = false;

  const enabled = algolia.config.analytics_enabled;
  if (!enabled) return;

  // useCookie parameter set up
  const userTokenAdminSetting = algolia.config.usertoken_with_cookies === 'enabled';
  // Generate a random alpha-numeric string that's 20 characters long
  const randomUserToken = Array.from(Array(20), () => Math.floor(Math.random() * 36).toString(36)).join('');

  if(userTokenAdminSetting) {
    window.Shopify.loadFeatures(
      [
        {
          name: 'consent-tracking-api',
          version: '0.1',
        },
      ],
      error => {
        if (error) {
          console.error("Customer Privacy API Error", error);
        }
        const userCanBeTracked = window.Shopify.customerPrivacy ? window.Shopify.customerPrivacy.userCanBeTracked() : false;
        const useCookie = userTokenAdminSetting && userCanBeTracked;
        insightsClient('init', {appId: algolia.config.app_id, apiKey: algolia.config.search_api_key, useCookie});
        !userCanBeTracked && insightsClient('setUserToken', randomUserToken);
        algolia.userTokenCheck = true;
      },
    );
  } else {
    insightsClient('init', {appId: algolia.config.app_id, apiKey: algolia.config.search_api_key});
    insightsClient('setUserToken', randomUserToken);
  }

  // Autocomplete insight initialization
  algolia.algoliaInsightsPlugin = createAlgoliaInsightsPlugin({ insightsClient });
  // IS insight initialization
  algolia.insightsMiddleware = createInsightsMiddleware({ insightsClient })

  // Local storage logic for conversion events
  const localStorageKey = 'algolia_analytics_clicked_objects';

  /**
   * Saves details in local storage for conversion tracking
   */
  algolia.saveForConversionTracking = function (data) {
    /**
     * We're using a try, catch here to handle any possible exceptions
     * resulting from local storage or JSON parsing.
     */
    try {
      // Get any data previously stored
      const previousClickItemsString = localStorage.getItem(localStorageKey) || '[]';
      const previousClickItems = JSON.parse(previousClickItemsString);

      var conversionData = data;

      if (conversionData.eventName === "click") {
        // Changing the event to 'Added to cart' from 'click'
        conversionData.eventName = 'Added to cart';
        // Removing the `positions` property if the event comes from IS
        delete conversionData.positions;
      }

      // Add the current products data to local storage
      previousClickItems.push(conversionData)
      localStorage.setItem(localStorageKey, JSON.stringify(previousClickItems))
    } catch (error) {
      // No need to do anything in this scenario
    }
  };

  /**
   * Try to get the details from local storage for conversion tracking.
   * We're using a try...catch here to handle any possible exceptions resulting
   * from local storage or JSON parsing.
   */
  function trackConversion() {

    //Retrieving userToken
    let userToken;
    insightsClient('getUserToken', null, (err, newUserToken) => {
      if (err) {
        console.error(err);
        return;
      }
      userToken = newUserToken;
    });

    try {
      // Get any previously stored data.
      const previousClickItemsString = localStorage.getItem(localStorageKey)
      // If data was found, send a conversion event for those products.
      if (!!previousClickItemsString) {
        const previousClickItems = JSON.parse(previousClickItemsString)
        previousClickItems.forEach((data) => {
          data = {...data, userToken};
          insightsClient('convertedObjectIDsAfterSearch', data)
        })
      }
    } catch (error) {
      // No need to do anything in this scenario.
    }

    // Try to remove the items from local storage.
    try {
      localStorage.removeItem(localStorageKey)
    } catch (error) {
      // No need to do anything in this scenario.
    }
  }

  /**
   *Track a conversion event when clicking the 'add to cart' button.
   *Change the query selector to be the correct one for your theme.
   */
  const addToCartBtn = document.querySelector('YOUR_ADD_TO_CART_SELECTOR')
  if (addToCartBtn) {
    addToCartBtn.addEventListener('click', function (e) {
      trackConversion()
    })
  }
})(window.algoliaShopify);
